////////LIBRARY/////////
import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isEqual } from 'lodash'
///////COMPONENTS///////
import Paper from './Paper'
import UseOutsideClick from '../../../../hooks/UseOutsideClick/UseOutsideClick'
/////////ASSETS/////////
import columnsFilter from '../../../../assets/icones/table/columns-filter.svg'

/////////STYLED/////////
const ColumnsFilterWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	border-radius: 3px;
	text-transform: ${(props) => (props.upper ? 'uppercase' : 'capitalize')};
	background-color: #e5e5e5;
	cursor: pointer;
	height: 32px;
	width: 32px;
	box-sizing: border-box;
`
const ContentCheckBoxWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr min-content;
	justify-items: center;
	align-items: center;
	width: 100%;
	height: 100%;
`
const ButtonImg = styled.img`
	height: 100%;
	width: 100%;
`
/////////STYLED/////////

const ColumnsFilter = ({ columns, setColumns }) => {
	const buttonRef = useRef()
	const [showPaper, setShowPaper] = useState(false)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleCloseButton = () => {
		setShowPaper(false)
	}
	UseOutsideClick(buttonRef, handleCloseButton)
	const handleOpenShowPaper = () => {
		setShowPaper((prev) => !prev)
	}

	///////////////////////////////// RENDER ///////////////////////////////////////

	return !isEqual(columns, []) ? (
		<ColumnsFilterWrapper ref={buttonRef}>
			<ContentCheckBoxWrapper onClick={handleOpenShowPaper}>
				<ButtonImg src={columnsFilter} />
			</ContentCheckBoxWrapper>
			<Paper columns={columns} setColumns={setColumns} showPaper={showPaper} />
		</ColumnsFilterWrapper>
	) : null
}

ColumnsFilter.propTypes = {
	columns: PropTypes.array.isRequired,
}

ColumnsFilter.defaultPropTypes = {
	columns: [],
}

export default ColumnsFilter
